import type { ReviewsCarouselData } from '@/types';
import { ReviewsCarousel } from './ReviewsCarousel';

interface ReviewsCarouselBlockProps {
  data: ReviewsCarouselData;
}

/**
 * Component-factory adapter for ReviewsCarousel.
 *
 * The factory passes a single `data` prop (parsed from the block's embedded
 * JSON); ReviewsCarousel is presentational and takes `reviews`. This thin
 * adapter bridges the two so ReviewsCarousel stays reusable by other call
 * sites and by the factory without changing its signature.
 */
export const ReviewsCarouselBlock = ({ data }: ReviewsCarouselBlockProps) => {
  const reviews = data?.reviews ?? [];

  if (reviews.length === 0) {
    return null;
  }

  return <ReviewsCarousel reviews={reviews} />;
};
